export const PICKUP = "pickup";
export const DELIVER = "deliver";
